import { Box, Button, Chip, CircularProgress, Divider, TextField, Typography, useTheme } from "@mui/material";
import { useConstants } from "../hooks/UseConstants";
import DeleteImage from '../images/icons/delete.png';
import { useWaits } from "../hooks/UseWait";
import GratWarningImage from "../images/icons/gray-warning.png";
import { FormattedMessage } from "react-intl";

function DeleteDialog({ onClickConfirm, onClickCancel, title, subtitle, hasInput, label, placeholder, warning }) {
    const { language } = useConstants();
    const { sendWait, setSendWait } = useWaits();
    const theme = useTheme();
    const isAr = language === "ar";

    return (
        <Box
            sx={{
                backgroundColor: theme.palette.background.paper,
                width: { xs: "92%", sm: "78%", md: "42%" },
                maxWidth: 560,
                borderRadius: 4,
                overflow: "hidden",
                boxShadow: "0 24px 60px rgba(15,23,42,0.18)",
            }}
            dir={isAr ? "rtl" : "ltr"}
        >
            <Box
                sx={{
                    px: 3,
                    py: 2.5,
                    background: "linear-gradient(135deg, #fee2e2 0%, #fff1f2 100%)",
                    borderBottom: "1px solid",
                    borderColor: theme.palette.mode === "dark" ? "divider" : "#ffe4e6",
                    textAlign: "center",
                }}
            >
                <Box
                    sx={{
                        width: 76,
                        height: 76,
                        bgcolor: "#fecaca",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mx: "auto",
                        mb: 2,
                    }}
                >
                    <img src={DeleteImage} alt="" />
                </Box>
                <Chip
                    label={isAr ? "إجراء حساس" : "Sensitive action"}
                    size="small"
                    sx={{ mb: 1.25, bgcolor: "#fff", color: "#b91c1c", fontWeight: 700 }}
                />
                <Typography className="text-center !font-semibold" variant="h6">{title}</Typography>
                <Typography className="text-center !mt-2" variant="body2" sx={{ color: "text.secondary" }}>{subtitle}</Typography>
            </Box>

            <Box sx={{ p: 3 }}>
                {hasInput ? (
                    <TextField
                        dir={isAr ? "rtl" : "ltr"}
                        multiline
                        rows={4}
                        placeholder={placeholder}
                        className="w-full"
                        variant="outlined"
                        label={label}
                    />
                ) : null}

                {warning ? (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 1,
                            mt: hasInput ? 2 : 0,
                            p: 1.5,
                            borderRadius: 2,
                            bgcolor: theme.palette.mode === "dark" ? "rgba(245,158,11,0.12)" : "#fff7ed",
                            border: "1px solid",
                            borderColor: theme.palette.mode === "dark" ? "rgba(245,158,11,0.25)" : "#fed7aa",
                        }}
                    >
                        <img src={GratWarningImage} alt="" />
                        <Typography variant="body2" sx={{ color: "text.secondary" }}>{warning}</Typography>
                    </Box>
                ) : null}

                <Divider sx={{ my: 3 }} />

                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, justifyContent: "flex-end" }}>
                    <Button
                        variant="outlined"
                        disabled={sendWait}
                        sx={{ minWidth: 130 }}
                        onClick={onClickCancel}
                    >
                        <FormattedMessage id='cancel' />
                    </Button>
                    <Button
                        onClick={async () => { setSendWait(true); await onClickConfirm(); setSendWait(false); onClickCancel(); }}
                        variant="contained"
                        sx={{
                            minWidth: 150,
                            bgcolor: "#dc2626",
                            fontWeight: 700,
                            boxShadow: "0 4px 14px rgba(220,38,38,0.28)",
                            "&:hover": { bgcolor: "#b91c1c" },
                        }}
                    >
                        {sendWait ? <CircularProgress size={20} color="inherit" /> : <FormattedMessage id='delete' />}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}

export default DeleteDialog;